import { useTranslation } from 'react-i18next'
import { Form } from 'formik'
import styled from 'styled-components'
import { colors } from '@/styles'
import TenancyDetails from './tenancy-details'
import RentDetails from './rent-details'

const LeaseTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  margin: 8px auto 16px;

  span {
    color: ${colors.rainbowRed};
    margin-left: 4px;
  }
`

const DropdownContainer = styled.div`
  margin: 16px 0px 36px;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  background-color: ${colors.white};
`

const FormContainer = ({ values, setFieldValue, setFieldTouched, validateForm, currentStep }) => {
  const { t } = useTranslation()

  return (
    <Form>
      <div>
        <LeaseTitle>
          {t('l.contract_edit.lease_terms.tenancy_details.title', 'Tenancy Details')}
          <span>*</span>
        </LeaseTitle>
        <DropdownContainer>
          <TenancyDetails
            values={values}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
          />
        </DropdownContainer>
      </div>
      <div>
        <LeaseTitle>
          {t('l.contract_edit.lease_terms.rent_details.title', 'Rent Details')}
          <span>*</span>
        </LeaseTitle>
        <DropdownContainer>
          <RentDetails
            values={values}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
          />
        </DropdownContainer>
      </div>
    </Form>
  )
}

export default FormContainer
